<script lang="ts" src="./component.ts"></script>
<style lang="scss" src="./component.scss"></style>

<template>
  <section class="knowledge-test__risks" aria-labelledby="knowledge-risk-title">
    <h3 id="knowledge-risk-title">
      {{ $t("Подтверждение ознакомления с рисками") }}
    </h3>
    <p>
      {{
        $t(
          "Настоящим подтверждаю, что вопросы мне понятны, ответы выбраны мною самостоятельно. ОсОО «МЕКС» уведомило меня о следующих основных рисках и особенностях:"
        )
      }}
    </p>
    <ul>
      <li v-for="risk in risks" :key="risk">{{ $t(risk) }}</li>
    </ul>
    <label
      class="knowledge-test__consent"
      :class="{ 'knowledge-test__consent--selected': modelValue }"
      ><input
        type="checkbox"
        :checked="modelValue"
        :disabled="disabled"
        @change="changeConsent"
      /><span>{{
        $t(
          "Подтверждаю, что ознакомлен(а) с указанными рисками, понимаю их и принимаю решение о совершении операций самостоятельно."
        )
      }}</span></label
    >
  </section>
</template>
